import { Box, TableCell } from "@mui/material"
import { ArrowDownwardOutlined, ArrowUpwardOutlined } from "@mui-symbols-material/w300"
import type { Header } from "@tanstack/react-table"
import { flexRender } from "@tanstack/react-table"
import type { ReactElement } from "react"
import { twMerge } from "tailwind-merge"

import { getColumnSizeStyles } from "@/components/Tables/Aeros/utils"

interface TableHeaderCellProps<TData> {
  header: Header<TData, unknown>
  className?: string
}

export const TableHeaderCell = <TData,>({ header, className }: TableHeaderCellProps<TData>): ReactElement => {
  const align = header.column.columnDef.meta?.align

  return (
    <TableCell
      key={header.id}
      align={align}
      sx={getColumnSizeStyles(header.column.columnDef)}
      className={twMerge("z-[21]", className, header.column.getCanSort() ? "cursor-pointer" : "")}
      data-testid={`header-${header.id}`}
      onClick={header.column.getToggleSortingHandler()}
    >
      <Box className='flex items-center gap-x-2'>
        {header.column.getCanSort() &&
          {
            asc: <ArrowUpwardOutlined fontSize='small' />,
            desc: <ArrowDownwardOutlined fontSize='small' />,
            false: null,
          }[header.column.getIsSorted() as string]}
        {flexRender(header.column.columnDef.header, header.getContext())}
      </Box>
    </TableCell>
  )
}
